<template>
  <div class="categorie-card">
    <NuxtLink
      :to="getCategoryLink(category)"
      class="category-card-head"
    >
      <NuxtImg
        :src="category.dark_icon"
        :alt="category.name"
        loading="lazy"
        :custom="true"
        v-slot="{ src, isLoaded, imgAttrs }"
      >
        <img v-if="isLoaded" v-bind="imgAttrs" :src="src" />
        <img v-else :src="'/website/assets/img/default-featured-image.jpeg'" />
      </NuxtImg>
      <span>{{ category.name }}</span>
    </NuxtLink>

    <ul class="category-card-content" v-if="activeSubCategories.length">
      <li v-for="sub in activeSubCategories" :key="sub.id">
        <NuxtLink :to="getSubCategoryLink(sub)">
          {{ sub.name }}
        </NuxtLink>

        <ul v-if="getSubSubList(sub).length" class="category-card-content padding-right-15">
          <li v-for="subsub in getSubSubList(sub)" :key="subsub.id">
            <NuxtLink :to="getSubSubCategoryLink(subsub)">
              – {{ subsub.name }}
            </NuxtLink>
          </li>
        </ul>
      </li>
    </ul>
  </div>
</template>

<script setup lang="ts">
import { onMounted, computed } from 'vue'
import { useCategoriesStore } from '@/store/categoriesStore'
import type { PlaceCategory, SubCategory } from '~/types/types'

const props = defineProps<{ category: PlaceCategory }>()
const categoriesStore = useCategoriesStore()

onMounted(async () => {
  if (props.category.have_children && !categoriesStore.subCategories[props.category.id]) {
    try {
      await categoriesStore.fetchSubCategories(props.category.id)
    } catch (error) {
      console.error('Error loading subcategories:', error)
    }
  }
})

const getSubSubCategories = async (sub: SubCategory) => {
  if (sub.have_children && !categoriesStore.subSubCategories[sub.id]) {
    try {
      await categoriesStore.fetchSubSubCategories(sub.id)
    } catch (error) {
      console.error('Error loading sub-subcategories:', error)
    }
  }
}

const activeSubCategories = computed(() => {
  const subs = categoriesStore.subCategories[props.category.id] || []
  subs.forEach((sub: SubCategory) => getSubSubCategories(sub))
  return subs
})

const getSubSubList = (sub: SubCategory): SubCategory[] => {
  return categoriesStore.subSubCategories[sub.id] || []
}

// Link helpers
const slugify = (text: string): string => text ? text.trim().replace(/\s+/g, '-').toLowerCase() : ''
const getCategoryLink = (category: PlaceCategory): string => `/category/${category.id}/${slugify(category.name)}`
const getSubCategoryLink = (sub: SubCategory): string => `/category/${sub.id}/${slugify(sub.name)}`
const getSubSubCategoryLink = (subsub: SubCategory): string => `/category/${subsub.id}/${slugify(subsub.name)}`
</script>

<style scoped>

</style>
